import * as React from "react"
import { graphql } from "gatsby"
import VideoCard, { VideoCardProps } from "./VideoCard"
import StandardCard, { StandardCardProps } from "./StandardCard"

export type CardProps = {
  desktopRight: boolean
  displayFullWidth?: boolean
  card: {
    title: string
    cardData: VideoCardProps | StandardCardProps
  }
}


export default function Card(props: CardProps) {
  const cardProps = props.card.cardData[0]
  const { displayFullWidth = false} = props;
  const type = cardProps.id.replace(/[0-9]|Card-|DatoCms/g, '')
  const renderCard = (type: string) => {
    switch(type) {
      case 'Video':
        return <VideoCard {...cardProps} />
      default:
        return <StandardCard {...cardProps} displayFullWidth={displayFullWidth}/>
    }
  }
  
  return renderCard(type)
}

export const query = graphql`
  fragment CardContent on Card {
    desktopRight
    displayFullWidth
    card {
      ... on ReusableCard {
        title
        cardData: cardType {
          ...VideoCardContent
          ...StandardCardContent
        }
      }
    }
  }
`